import React, { useEffect, useCallback, useState} from 'react';
import PadComponent from './PadComponent.js';
import {connect} from 'react-redux';
import '../../Pads2.scss';

const PadsContainer = ({pads, scrollContainer}) => { 
    return (
        <div
          className="pads-container">
          {pads.map(
              (pad, i) => <PadComponent key={i} scrollContainer={scrollContainer} pad={pad}/>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      pads: props.subSequence ?
          props.subSequence.pads : props.sequencerEngine.currentSubSequence.pads
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadsContainer);
